<template>

<div class="tph">
    <div class="tph__screen" :class="[{ 'is-off': !isOn }, markierung('screen')]">
        <template v-if="isOn">

            <div class="content">
                <header class="status">
                    <div class="status-icons">
                        <svg v-for="name in statusIcons" :key="name" class="ic" viewBox="0 0 24 24">
                            <path v-for="(d, i) in icons[name]" :key="i" :d="d" />
                        </svg>
                    </div>

                    <div class="bars volume" :class="markierung('volumeBars')">
                        <svg class="ic ic--volume" viewBox="0 0 24 24">
                            <path v-for="(d, i) in icons.loud" :key="i" :d="d" />
                        </svg>
                        <span v-for="n in 7" :key="'vol' + n" class="bar" :class="{ on: n <= volume }"></span>
                    </div>
                </header>

                <div class="info" v-if="screen !== 'list' && screen !== 'confirmOff'" :class="markierung('info')">
                    <template v-if="channel">
                        <div class="channel-row">
                            <p class="mode-label">
                                <svg class="ic ic--mode" :class="{ 'ic--mode-system': modeIcon === 'system' }" viewBox="0 0 24 24">
                                    <path v-for="(d, i) in icons[modeIcon]" :key="i" :d="d" />
                                </svg>
                                <span>{{ commMode === 'G' ? 'Grp' : 'Dir' }}</span>
                            </p>
                            <p class="channel">{{ commMode }}{{ channel }}</p>
                        </div>
                        <p v-if="isTransmitting" class="txrx">T</p>
                    </template>
                    <template v-else>
                        <p class="offline">&lt; Nicht in Kom. &gt;</p>
                        <p class="offline-brand">POLYCOM</p>
                    </template>
                </div>

                <main class="main">
                    <div v-if="screen === 'list'" class="channel-list">
                        <div class="channel-list__track" :style="{ transform: `translateY(-${listIndex * 36}px)` }">
                            <div v-for="(ListChannel, index) in currentList" :key="ListChannel.number" class="channel-list__item" :class="{selected: index === listIndex}">
                                <p>{{ ListChannel.label }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="screen == 'confirmOff'">
                        <p>Wollen Sie das Endgerät ausschalten?</p>
                    </div>
                    <div v-else class="readout">
                        <div class="signal-group" :class="markierung('signal')">
                            <div class="bars rail signal">
                                <span v-for="n in 7" :key="'sig' + n" class="bar" :class="{ on: n > 1 }"></span>
                            </div>
                            <svg class="ic ic--signal" viewBox="0 0 24 24">
                                <path v-for="(d, i) in icons.system" :key="i" :d="d" />
                            </svg>
                        </div>
                        <p class="picture-placeholder">ZSO</p>
                        <div class="battery-group" :class="markierung('battery')">
                            <div class="bars rail battery-rail" :class="batteryLevel">
                                <span v-for="n in 7" :key="'batt' + n" class="bar" :class="{ on: n > 7 - batteryBars }"></span>
                            </div>
                            <svg class="ic ic--battery" viewBox="0 0 24 24">
                                <path v-for="(d, i) in icons.battery" :key="i" :d="d" />
                            </svg>
                        </div>
                    </div>
                </main>

                <footer class="softkeys" :class="markierung('softkeys')">
                    <span :class="{ 'softkeys--small': screen }">{{ softkeyLabel('D', 'Dir') }}</span>
                    <span :class="{ 'softkeys--small': screen === 'list' }">{{ middleLabel }}</span>
                    <span :class="{ 'softkeys--small': screen }">{{ softkeyLabel('G', 'Grp') }}</span>
                </footer>
            </div>

        </template>
    </div>

    <div class="crosshair">
        <button class="selector-left" :class="markierung('selectorD')" @click="pressMode('D')">-</button>
        <button class="nav-up" :class="markierung('navUp')" @click="arrowUp">
            <svg class="ic ic--nav" viewBox="0 0 24 24">
                <path v-for="(d, i) in icons.arrowUp" :key="i" :d="d" />
            </svg>
        </button>
        <button class="selector-right" :class="markierung('selectorG')" @click="pressMode('G')">-</button>

        <button class="nav-left">
            <svg class="ic ic--nav" viewBox="0 0 24 24">
                <path v-for="(d, i) in icons.arrowLeft" :key="i" :d="d" />
            </svg>
        </button>
        <button class="ok" :class="markierung('ok')" @click="buttonOkay">OK</button>
        <button class="nav-right">
            <svg class="ic ic--nav" viewBox="0 0 24 24">
                <path v-for="(d, i) in icons.arrowRight" :key="i" :d="d" />
            </svg>
        </button>

        <button class="phone-pickup">
            <svg class="ic--call" viewBox="0 0 24 24">
                <path v-for="(d, i) in icons.call" :key="i" :d="d" />
            </svg>
        </button>
        <button class="nav-down" :class="markierung('navDown')" @click="arrowDown">
            <svg class="ic ic--nav" viewBox="0 0 24 24">
                <path v-for="(d, i) in icons.arrowDown" :key="i" :d="d" />
            </svg>
        </button>
        <button class="phone-hangup" :class="markierung('hangup')" @pointerdown="startHangupHold" @pointerup="cancelHangupHold" @pointercancel="cancelHangupHold">
            <svg class="ic--call ic--call-hangup" viewBox="0 0 24 24">
                <path v-for="(d, i) in icons.call" :key="i" :d="d" />
            </svg>
        </button>
    </div>

    <div class="digits" :class="markierung('digits')">
        <button v-for="key in keys" :key="key" @click="pressKey(key)">{{ key }}</button>
    </div>
</div>

</template>

<script>
import { icons } from '@/data/Icons.js'

export default {
    data() {
        return { icons }
    },
    props: {
        isOn: Boolean,
        channel: [String, Number],
        volume: Number,
        battery: Number,
        isTransmitting: Boolean,
        commMode: String,
        currentList: Array,
        listIndex: Number,
        screen: String,
        pendingMode: String,
        // Namen der Teile, die die Erklaerung gerade anleuchtet. Immer ein
        // Array — ein Schritt darf auf mehrere Stellen zeigen, etwa auf
        // beide Auswahltasten bei Ja/Nein.
        highlight: {
            type: Array,
            default: () => []
        },
        // Ziel des Lernmodus-Guides. Eigene Prop und eigene Darstellung:
        // der Guide dunkelt nicht ab und das Geraet muss bedienbar bleiben,
        // der Hinweis pulsiert also nur statt anzuheben und zu sperren.
        guideTarget: String
    },
    computed: {
        batteryBars() {
            const steps = [15, 30, 45, 60, 75, 85, 95]
            return steps.filter(s => this.battery >= s).length
        },
        batteryLevel() {
            if (this.battery <= 30) return 'level-low'
            if (this.battery <= 60) return 'level-mid'
            return 'level-high'
        },
        middleLabel() {
            if (this.screen === 'list') return 'Eintreten'
            if (this.screen === 'input' || this.screen === 'confirmOff') return ''
            return 'Menü'
        },
        statusIcons() {
            return ['lock', 'loud', 'profile']
        },
        modeIcon() {
            return this.commMode === 'G' ? 'system' : 'direct'
        }
    },
    methods: {
        istZiel(name) {
            return this.highlight.includes(name)
        },
        /**
         * Eine einzige Stelle entscheidet, wie ein Teil markiert wird.
         * Erklaerung schlaegt Guide — beide zugleich gibt es nicht, die
         * beiden Modi schliessen sich aus.
         * Alles aus INNEN liegt hinter overflow: hidden und braucht darum
         * einen inneren Ring; aussen liegende Teile vertragen ein outline.
         */
        markierung(name) {
            const INNEN = ['volumeBars', 'battery', 'signal', 'info', 'softkeys']
            if (this.istZiel(name)) return INNEN.includes(name) ? 'spot-innen' : 'spot'
            if (this.guideTarget === name) return INNEN.includes(name) ? 'guide-highlight-innen' : 'guide-highlight'
            return null
        },
        /**
         *
         */
        softkeyLabel(mode, idleLabel) {
            if (!this.screen) return idleLabel
            if (this.screen === 'confirmOff' && mode === 'D') return 'Ja'
            if (this.screen === 'confirmOff' && mode === 'G') return 'Nein'
            if (mode === 'G') return this.screen === 'input' ? 'Durchsuchen' : ''
            return 'Zurück'
        }
    },
    setup(props, {emit}) {
        const keys = ['1','2','3','4','5','6','7','8','9','*','0','#']
        let Timer = null

        const pressKey = (key) => {
            emit('key', key)
        }

        const pressMode = (mode) => {
            emit('mode', mode)
        }

        const arrowUp = () => {
            emit('up')
        }

        const arrowDown = () => {
            emit('down')
        }

        const buttonOkay = () => {
            emit('confirm')
        }

        const startHangupHold = () => {
            Timer = setTimeout(() => {
                emit('exitChannel')
            }, 1500)
        }

        const cancelHangupHold = () => {
            clearTimeout(Timer)
        }

        return {keys, pressKey, pressMode, arrowDown, arrowUp, buttonOkay, startHangupHold, cancelHangupHold}
    }
}

</script>

<style scoped>
.tph {
    --w: 240px;
    --h: 320px;
    width: var(--w);
}

.tph__screen {
    width: 100%;
    height: var(--h);
    box-sizing: border-box;
    padding: 6px;
    display: flex;
    flex-direction: row;
    background: #1a1d22;
    color: #101b2c;
    /* Instrumentenschrift fuer den Bildschirm. Nur Systemschriften, keine
       Abhaengigkeit, kein Nachladen — Windows faellt auf Cascadia/Consolas,
       macOS auf SF Mono/Menlo, Linux auf DejaVu.
       Zurueck auf die alte Zeile: font-family: "Helvetica Neue", Arial, sans-serif; */
    font-family: "Cascadia Mono", Consolas, "SF Mono", Menlo, "DejaVu Sans Mono", monospace;
    letter-spacing: 0.01em;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

.tph__screen.is-off {
    background: #0d1014;
}

.content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    background: #f2f4f7;
    border-radius: 2px;
    overflow: hidden;
}

.status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px;
    background: rgb(242, 242, 242);
    border-bottom: 1px solid rgb(161, 161, 161);
}

.status .ic {
    stroke: #000000;
}

.status .bar {
    background: rgba(0, 0, 0, 0.25);
}

.status .bar.on {
    background: #000000;
}

.status-icons {
    display: flex;
    align-items: center;
    gap: 6px;
}

.ic {
    width: 20px;
    height: 20px;
    fill: none;
    stroke: #ffffff;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    opacity: 0.85;
}

.bars {
    display: flex;
    align-items: flex-end;
    gap: 2px;
}

.bars.volume {
    align-items: center;
    gap: 4px;
}

.bar {
    width: 4px;
    height: 12px;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 1px;
}

.bar.on {
    background: #ffffff;
}

.bars.rail {
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.bars.rail .bar {
    width: 14px;
    height: 7px;
    background: transparent;
    border: 1px solid #101b2c;
    border-radius: 1px;
}

.bars.rail.signal .bar.on {
    background: #4fc3f7;
}

.battery-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.ic--battery {
    width: 20px;
    height: 20px;
    stroke: #000000;
}

.signal-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.ic--signal {
    width: 20px;
    height: 20px;
    stroke: #000000;
}

.battery-rail.level-high .bar.on {
    background: #2ecc71;
}

.battery-rail.level-mid .bar.on {
    background: #f39c12;
}

.battery-rail.level-low .bar.on {
    background: #e74c3c;
}

.info {
    position: relative;
    flex: 0 0 28%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: rgb(242, 242, 242);
    border-bottom: 1px solid rgb(161, 161, 161);
}

.channel-row {
    position: absolute;
    top: 4px;
    left: 8px;
    display: flex;
    align-items: center;
    gap: 18px;
}

.mode-label {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 1rem;
    font-weight: 700;
    color: #40546f;
}

.ic--mode {
    width: 18px;
    height: 18px;
    stroke: #000000;
}

.ic--mode-system {
    transform: scale(1.4);
}

.info .txrx {
    position: absolute;
    bottom: 0;
    left: 8px;
}

.offline {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 700;
}

.offline-brand {
    margin: 4px 0 0;
    font-size: 0.85rem;
    color: #40546f;
    letter-spacing: 0.08em;
}

.main {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    background: rgb(255, 255, 255);
}

.readout {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
}

.picture-placeholder {
    margin: 0;
    padding: 4px 10px;
    border: 1px dashed #9fb0c7;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 700;
    color: #40546f;
    letter-spacing: 0.05em;
}

.channel {
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

.channel-list {
    width: 100%;
    height: 216px;
    overflow: hidden;
    padding: 0 4px;
    box-sizing: border-box;
    position: relative;
}

.channel-list__track {
    display: flex;
    flex-direction: column;
    transition: transform 0.15s ease;
}

.channel-list__item {
    height: 32px;
    margin-bottom: 4px;
    padding: 0 10px;
    border-radius: 4px;
    font-size: 1.1rem;
    color: #101b2c;
    display: flex;
    align-items: center;
    box-sizing: border-box;
}

.channel-list__item p {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.channel-list__item.selected {
    background: #3b6ea5;
    color: #ffffff;
    font-weight: 700;
}

.txrx {
    padding: 4px 14px;
    border-radius: 4px;
    background: #1e7a4b;
    color: #ffffff;
    font-weight: 700;
    letter-spacing: 0.05em;
}

.softkeys {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: flex-end;
    padding: 6px 10px;
    background: rgb(255, 255, 255);
    color: #000000;
    font-size: 1.1rem;
    font-weight: 600;
    letter-spacing: 0.02em;
}

.softkeys span:first-child {
    justify-self: start;
}

.softkeys span:last-child {
    justify-self: end;
}

.softkeys span:nth-child(2) {
    justify-self: center;
    font-size: 1.35rem;
}

.softkeys span.softkeys--small {
    font-size: 0.8rem;
}

.crosshair {
    width: var(--w);
    margin-top: 12px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    box-sizing: border-box;
}

.crosshair button {
    height: 40px;
    border: none;
    border-radius: 6px;
    background: rgb(65, 65, 65);
    color: #f2f4f7;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 0 0 1px #000, 0 2px 4px rgba(0, 0, 0, 0.3);
}

.ic--nav {
    width: 16px;
    height: 16px;
    stroke: #f2f4f7;
}

.ic--call {
    width: 26px;
    height: 26px;
    fill: #1e7a4b;
}

.ic--call-hangup {
    fill: #c0392b;
    transform: rotate(135deg);
}

.crosshair button:active {
    background: rgb(45, 45, 45);
}

.selector-left,
.selector-right {
    width: 60px;
    background: linear-gradient(180deg, #4a80b5, #3b6ea5);
    color: rgb(161, 190, 212);
    font-size: 1.2rem;
    font-weight: 700;
}

.selector-left {
    justify-self: start;
}

.selector-right {
    justify-self: end;
}

.nav-up,
.nav-left,
.nav-right,
.nav-down {
    width: 34px;
    height: 28px;
    font-size: 0.8rem;
    justify-self: center;
}

.nav-left {
    justify-self: end;
    margin-right: -14px;
}

.nav-right {
    justify-self: start;
    margin-left: -14px;
}

.ok {
    width: 40px;
    height: 40px;
    justify-self: center;
    background: linear-gradient(180deg, #4a80b5, #3b6ea5);
}

.phone-pickup {
    width: 60px;
    justify-self: start;
    background: linear-gradient(180deg, #3fbf6f, #2ecc71);
}

.phone-hangup {
    width: 60px;
    justify-self: end;
    background: linear-gradient(180deg, #d9534f, #c0392b);
}

.digits {
    width: var(--w);
    margin-top: 12px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    box-sizing: border-box;
}

.digits button {
    height: 36px;
    border: none;
    border-radius: 6px;
    background: rgb(65, 65, 65);
    color: #f2f4f7;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: inset 0 0 0 1px #000, 0 2px 4px rgba(0, 0, 0, 0.3);
}

.digits button:active {
    background: rgb(45, 45, 45);
}
/* ─── Spotlight der Erklaerungen ──────────────────────────────
   Hebt ein Teil ueber die Abdunklung (z-index 100) in Funkgeraet.vue.
   z-index wirkt nur an positionierten Elementen, darum ueberall
   position: relative. Kein border-radius hier — der Umriss folgt von
   selbst dem Radius des Elements.
   .spot-innen ist fuer alles INNERHALB des Displays: .content und
   .tph__screen schneiden mit overflow: hidden ab, ein aussen liegender
   Ring waere dort halb weggeschnitten. */

.spot {
    position: relative;
    z-index: 101;
    outline: 3px solid var(--zs-orange);
    outline-offset: 3px;
}

/* Waehrend einer Erklaerung ist das Geraet eingefroren. Alles ausser dem
   angeleuchteten Teil liegt ohnehin unter der Abdunklung und ist nicht
   anklickbar; nur das angehobene Teil waere es noch. Damit ein gestellter
   Bildschirm nicht durch einen Klick zerfaellt, nimmt es hier keine
   Zeiger mehr an. Die Knoepfe der Blase liegen darueber (102). */
.spot,
.spot-innen {
    pointer-events: none;
}

.spot-innen {
    position: relative;
    z-index: 101;
    box-shadow: inset 0 0 0 2px var(--zs-orange);
}


/* ─── Markierung des Lernmodus-Guides ─────────────────────────
   Kein Anheben, kein pointer-events: none — waehrend des Guides
   soll das Geraet bedienbar bleiben, der Schritt wird ja durch
   Tun erledigt. Nur ein pulsierender Hinweis.
   Gleiche Farbe und Taktung wie .guide-highlight in Funkgeraet.vue;
   die Regel steht hier zweimal, weil scoped styles nicht ueber
   Komponentengrenzen wirken. */
.guide-highlight {
    animation: guide-puls 1s ease-in-out infinite;
}

.guide-highlight-innen {
    animation: guide-puls-innen 1s ease-in-out infinite;
}

@keyframes guide-puls {
    0%, 100% {
        outline: 4px solid rgba(179, 38, 30, 0.95);
        outline-offset: 2px;
    }
    50% {
        outline: 4px solid rgba(179, 38, 30, 0.2);
        outline-offset: 6px;
    }
}

@keyframes guide-puls-innen {
    0%, 100% { box-shadow: inset 0 0 0 2px rgba(179, 38, 30, 0.95); }
    50%      { box-shadow: inset 0 0 0 2px rgba(179, 38, 30, 0.2); }
}

/* ─── Foto statt Zeichnung ───────────────────────────────────
   Gegenstueck zum Abschnitt in Funkgeraet.vue: Bildschirm und Tasten
   liegen absolut auf dem Foto. --s und --c kommen von .chassis, die
   Masse sind Pixel im Foto (--x/--y links oben, --b/--h Groesse). */
.tph {
    width: auto;
}

/* Das LCD im Foto ist 126 px breit, das Display misst innen 240 px.
   zoom statt transform: kein eigener Stapelkontext, .spot-innen kommt
   weiter ueber die Abdunklung. zoom wirkt auch auf left/top des
   Elements selbst, darum dort in Display-Pixeln (Fotopixel mal 240/126).
   Ohne eigenen Rand und Hintergrund: das Foto liefert beides, und
   ausgeschaltet zeigt es sein eigenes, leeres LCD. */
.tph__screen,
.tph__screen.is-off {
    position: absolute;
    zoom: calc(var(--s) * 126 / 240);
    left: calc(108px * 240 / 126);
    top: calc((375px - var(--c)) * 240 / 126);
    width: var(--w);
    padding: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
}

.crosshair button {
    position: absolute;
    margin: 0;
    left: calc(var(--x) * var(--s) * 1px);
    top: calc((var(--y) * 1px - var(--c)) * var(--s));
    width: calc(var(--b) * var(--s) * 1px);
    height: calc(var(--h) * var(--s) * 1px);
}

.selector-left  { --x: 95;  --y: 604; --b: 36; --h: 24; }
.selector-right { --x: 212; --y: 604; --b: 36; --h: 24; }
.nav-up         { --x: 156; --y: 601; --b: 30; --h: 26; }
.nav-left       { --x: 131; --y: 627; --b: 24; --h: 26; }
.ok             { --x: 157; --y: 629; --b: 27; --h: 23; }
.nav-right      { --x: 186; --y: 627; --b: 24; --h: 26; }
.nav-down       { --x: 156; --y: 655; --b: 30; --h: 26; }
.phone-pickup   { --x: 95;  --y: 652; --b: 39; --h: 30; }
.phone-hangup   { --x: 209; --y: 652; --b: 39; --h: 30; }

/* Ziffernblock: 3 x 4 Tasten in einem Raster ueber dem Foto. */
.digits {
    position: absolute;
    margin: 0;
    left: calc(92px * var(--s));
    top: calc((692px - var(--c)) * var(--s));
    width: calc(160px * var(--s));
    height: calc(102px * var(--s));
    grid-template-rows: repeat(4, 1fr);
    gap: calc(8px * var(--s)) calc(16px * var(--s));
}

.digits button {
    height: auto;
}

.crosshair button,
.digits button {
    background: transparent;
    box-shadow: none;
    color: transparent;
}

.crosshair svg {
    visibility: hidden;
}

.crosshair button:active,
.digits button:active {
    background: rgba(0, 0, 0, 0.3);
}

/* .spot setzt oben position: relative; hier muessen die Teile absolut
   bleiben, sonst fallen sie beim Anleuchten aus dem Foto. */
.tph__screen.spot,
.tph__screen.spot-innen,
.crosshair button.spot,
.digits.spot {
    position: absolute;
}
</style>
